<template>
    <div class="msg">
        <v-select id="event" v-model="event_id" :items="events" :label="getI18n('event')" :disabled="params.event.disabled"></v-select>
    </div>
</template>

<script>
    import store from '@/store'
    import i18n from '@/i18n'
    import {Api} from '@/core/api.js';
    const api = new Api();

    export default {
        props: { params: Object },
        components: { },
        data() {
            return {
                event_id: this.params.event.value,
            }
        },
        computed: {
            events: function(){
                var events = store.getters[ 'events/getActives' ]();
                var aEvents = [];
                for( var i in events ){
                    var e = events[ i ];
                    aEvents.push( { text: this.formatEventName( e.name, e.edition ), value: e.id } );
                }

                return aEvents;
            },
            users: function() {
                var users = store.getters[ 'user/getList' ]();
                var aUsers = [];
                for( var i in users ){
                    var u = users[ i ];
                    aUsers.push( { text: u.name, value: u.id } );
                }

                return aUsers;
            }
        },
        methods: {
            getI18n( label ){
                return i18n.t( label );
            },

            formatEventName( name, edition ){
                return name + "'" + edition.substring(2);
            },

            formatParam( param ){
                switch( param.type ){
                    case 'string': return param.value;
                    case 'role': return param.value.name;
                    case 'email': return param.value;
                    case 'phone': return "<v-icon size='18px'>phone</v-icon>" + param.value;
                }
            }
        },
        created() {            
            var self = this;
            api.get( 'club' ).then( function( response ){
                if( response.status ){
                    var data = response.data;
                    var aClubs = [];
                    for( var i in data ){
                        aClubs.push( { text: data[i].name, value: data[i].id } )
                    }
                    
                    self.clubs = aClubs
                }
            });
        },
        watch: {
            event_id: {
                handler( v ){
                    this.params.event.value = v
                },
                deep: true
            },
        }
    }
</script>

<style lang="scss" scoped>
    .avatar {
        width: 100%;
        height: 150px;
        text-align: center;

        img {
            height: 100%;
            width: auto;
        }
    }

    .item {
        text-align: center;
        margin: 10px auto;
        width: fit-content;

        &.strong .value {
            font-weight: bold;
            font-size: 22px;
        }

        &.role {
            border-radius: 15px;
            padding: 5px 15px;
            font-weight: lighter;
            margin: 0 auto;
            
            &.r5 {
                background-color: $bg-role-5;
                color: $co-role-5;
            }

            & .value {
                font-size: 18px;
                text-transform: uppercase;
            }
        }
        
        &.club {
            position: relative;
        }
    }
</style>